
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import Image from "@/components/ui/image";
import { Wrench, MapPin, Link2 } from "lucide-react";

interface AffiliateAdProps {
  showTitle?: boolean;
}

const AffiliateAds: React.FC<AffiliateAdProps> = ({ showTitle = true }) => {
  const affiliates = [
    {
      name: "Svenska Gummihuset",
      logo: "/lovable-uploads/bf8f8602-6261-4b9f-a826-fc75fdad4d22.png",
      description: "Laaja valikoima renkaita ja vanteita. Edistyksellinen rengas- ja vannevalitsin.",
      url: "https://go.adt253.net/t/t?a=1072371070&as=1854031059&t=2&tk=1",
      benefits: ["Kattava rengasvalikoima", "145,4€ pakettibonus", "Ilmainen toimitus"]
    },
    {
      name: "Skruvat.fi",
      logo: "/lovable-uploads/ff88513d-f6be-44fd-bf6b-37cc11121c49.png",
      description: "Pohjoismaiden johtava autovaraosien verkkokauppa. Yli 500 000 tuotteen valikoima.",
      url: "https://id.skruvat.fi/t/t?a=847000831&as=1854031059&t=2&tk=1",
      benefits: ["Laaja valikoima autovaraosia", "Nopea toimitus", "Kilpailukykyiset hinnat"]
    },
    {
      name: "Renkaat.com",
      logo: "/lovable-uploads/48a35eff-6b39-4413-aa44-c7d4116cc2fa.png", 
      description: "Kansainvälinen rengasvertailusivusto. Löydä parhaat tarjoukset ja merkit.",
      url: "https://do.renkaat.com/t/t?a=1328214709&as=1854031059&t=2&tk=1",
      benefits: ["Helppo hintavertailu", "Laaja tieverkosto", "Yksinkertainen tilausjärjestelmä"]
    }
  ];

  return (
    <section className="py-8 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        {showTitle && (
          <div className="mb-6 flex items-center justify-center">
            <Wrench className="h-5 w-5 text-blue-600 mr-2" />
            <h2 className="text-2xl md:text-3xl font-bold text-center">
              Suositellut kumppanimme
            </h2>
          </div>
        )}
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {affiliates.map((affiliate, idx) => (
            <Card key={idx} className="overflow-hidden hover:shadow-lg transition-shadow duration-300 h-full">
              <a 
                href={affiliate.url}
                target="_blank" 
                rel="noopener noreferrer"
                className="block h-full"
              >
                <div className="bg-white p-4 flex items-center justify-center h-20 md:h-28 border-b">
                  <div className="w-full h-full flex items-center justify-center">
                    <Image
                      src={affiliate.logo}
                      alt={`${affiliate.name} logo`}
                      className="max-h-full max-w-[80%]" 
                      fallbackSrc="/placeholder.svg"
                      priority={true}
                      objectFit="contain"
                      width={180}
                      height={60}
                    />
                  </div>
                </div>
                <CardContent className="p-4 pt-5">
                  <h3 className="font-bold text-lg mb-2 text-blue-700">{affiliate.name}</h3>
                  <p className="text-gray-700 text-sm mb-3">{affiliate.description}</p>
                  <div className="space-y-2">
                    {affiliate.benefits.map((benefit, bidx) => (
                      <div key={bidx} className="flex items-start">
                        <MapPin className="w-4 h-4 text-blue-500 mt-0.5 mr-2 flex-shrink-0" />
                        <span className="text-sm text-gray-600">{benefit}</span>
                      </div>
                    ))}
                  </div>
                  <div className="mt-4 pt-2 border-t flex items-center text-blue-600 text-sm font-medium">
                    <Link2 className="w-4 h-4 mr-1" />
                    <span>Siirry verkkokauppaan</span>
                  </div>
                </CardContent>
              </a>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AffiliateAds;
